<h3>สมัครใช้บริการ</h3>
<form autocomplete="off" #registerForm="ngForm" class="uk-margin-small-bottom uk-text-left">
  <div class="uk-text-left">
    <h5 style="margin-bottom: 0.3rem;">ตรวจสอบข้อมูลของท่าน เพื่อยืนยันตัวตน</h5>
  </div>
  <div class="uk-background-cover" style="padding:15px 15px 0px 15px"
    [ngStyle]="{'background-image': 'url('+bg_image+')'}"> 
    <div>
      <label for="id-card" class="uk-form-label" style="color: white;">เลขที่บัตรประจำตัวประชาชน</label>
      <div class="uk-position-relative">
        <input id="id-card" class="uk-input uk-border-rounded uk-text-bold uk-text-large"
          style="background-color:transparent; border: none;color: white;" type="text"
          placeholder="กรุณาระบุหมายเลขบัตรประชาชน" autocomplete="off" mask="0-00AA-AAAAA-00-0" name="idCard"
          #idCard="ngModel" [(ngModel)]="model().form.idcard.text" disabled />
      </div>
    </div>
    <hr style="margin: 0;margin-bottom: 0.2rem;">
    <div>
      <label for="mobile" class="uk-form-label" style="color: white;">หมายเลขโทรศัพท์มือถือ</label>
      <div class="uk-position-relative">
        <input id="mobile" class="uk-input uk-border-rounded uk-text-bold uk-text-large"
          style="background-color:transparent; border: none;color: white;" type="text"
          placeholder="กรุณาระบุหมายเลขโทรศัพท์มือถือ" mask="00A-AAA-A000" name="mobile" #mobile="ngModel"
          [(ngModel)]="model().form.mobile.text" disabled />
      </div>
    </div>
  </div>
  <div class="uk-padding-small"></div>
  @if(remarkText() != '') {
    <div class="uk-text-left uk-padding-small" style="background-color: #f8f8f8;">
      <small [innerHTML]="remarkText() | sanitizeHtml"></small>
    </div>
  }
  <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
    <button type="submit"
      class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
      (click)="onSubmit()">{{btnSubmitText()}}
    </button>
  </div>
</form>